export function getFlatTagText(flat, t) {
  return `${flat.building.title} ${t('Flat.FlatNumberKey')} ${flat.number}`
}

export function filterFlatsById(flats, id) {
  return flats.filter(flat => flat.value !== id)
}
